import MyAccount from "../components/MyAccount/MyAccount";

function MyAccountPage() {
  return <MyAccount />;
}

export default MyAccountPage;
